import React from 'react';
import { urls } from '../utils/urls.config';
import queryString from 'query-string';

const API_REQUEST_TOKEN= 'https://sistemas.ufvjm.edu.br/api/v1/reverse-token';


class HandleIntegrationRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasToken: false,
            invalidToken: false,
            responseMessage: ''
        }
    }

    componentDidMount() {
        
        const qs_values = queryString.parse(window.location.search);

        const { weak, token } = qs_values;

        this.setState({ hasToken: !!token });
        if (token && weak) this.fetchTokenInfo(token, weak);
    }


    fetchTokenInfo = async (token, weak) => {

        const lowerWeak = weak.toLowerCase();

        const validInfoWeak = (lowerWeak === 'true' || lowerWeak === 'false')

        if (!validInfoWeak) {
            this.setState({ invalidToken: true, responseMessage: 'Invalid query string' });
            return false;
        }

        const passwordWeak = (lowerWeak === 'true');
        
        const response = await fetch(API_REQUEST_TOKEN, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ token: token, weak: weak })
        });

        if (!response.ok) {
            const resp = await response.json();
            var message = '';

            if (Object.keys(resp).includes('error')) {
                message = resp.error.message;
            }

            this.setState({ invalidToken: true, responseMessage: message })
            return false;
        }

        const jsonResponse = await response.json();

        const { uid } = jsonResponse;
        const uri = jsonResponse.links.href;

        localStorage.setItem('token', token);

        if (passwordWeak) {
            // Redireciona para a url de alteração de senha
            return this.props.history.push({
                pathname: urls.change.path,
                state: { uid: uid, uri: uri, token: token }
            })
        }

        // redireciona para a tela de criação de conta institucional
        return this.props.history.push({
            pathname: urls.choices.path,
            state: { uid: uid, uri: uri, token: token }
        })

    }

    renderNotAllowed = (message) => {
        return (<span>Not Allowed: {message}</span>)
    }

    render() {
        const { hasToken, invalidToken, responseMessage } = this.state;

        if (!hasToken) return this.renderNotAllowed(responseMessage);
        if (invalidToken) return this.renderNotAllowed(responseMessage);

        return false;
    }
}

export default HandleIntegrationRequest;